import {useCollection} from '../../firebase/hooks/useCollection';
import {Collection} from '../../firebase/types';
import {WaitlistEntry} from '#common/auth/types';
import {SignupList} from '#common/firebase/collections';
import {IdGenerator} from '#common/models/Entity';

const WaitlistIdGenerator: IdGenerator<WaitlistEntry> = (waitlist) => waitlist.email;

export function useWaitlistCollection(): Collection<WaitlistEntry> {
  return useCollection<WaitlistEntry>(WaitlistIdGenerator, SignupList.waitlist);
}
